module.exports = __webpack_public_path__ + "static/media/games.d66ef748.svg";